import { useEffect, useRef, useState } from 'react'
import { Button } from '../../Components/ui/button'
import { useNavigate } from 'react-router-dom'
import { get } from '../../http/restservice'
import { getUserDetails } from '../../utils/AuthUtil'
import env from '../../env/env'
import { Star, ChevronLeft } from 'lucide-react'

const analyticsCards = [
  { id: 1, title: 'Fabits Short term fund', analytic: '17.62' },
  { id: 2, title: 'Fabits Mid term fund', analytic: '19.36' },
  { id: 3, title: 'Fabits Long term fund', analytic: '22.11' },
  { id: 4, title: 'NIFTY 50', analytic: '8.81' },
]

const Returns = () => {
  const navigate = useNavigate()
  const [Questions, setQuestions] = useState([])
  const [loginDetails, setLoginDetails] = useState({})
  const videoRef = useRef(null)

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.playbackRate = 0.5 // Adjust the speed (0.5 means half-speed)
    }
  }, [])

  useEffect(() => {
    setLoginDetails(getUserDetails())
  }, [])

  useEffect(() => {
    const fetchSavedResponse = async () => {
      if (!loginDetails.phoneNumber) return
      const url = `https://apimywealth.fabits.com/customerservice/api/firstIdeas`
      const phoneNumber = loginDetails?.phoneNumber
      try {
        const response = await get(url, {}, { phoneNumber })
        setQuestions(response)
      } catch (error) {
        console.log(error, 'error')
      }
    }

    fetchSavedResponse()
  }, [loginDetails.phoneNumber])

  return (
    <>
      {/* Desktop mode code */}
      <div className='bg-[#F6F6F9] font-IBM'>
        <div className='mx-auto hidden h-screen max-w-[1128px] lg:block'>
          {/* Back Button */}
          <div className='pt-6 pb-4'>
            <button
              onClick={() => navigate('/dashboard')}
              className='flex items-center gap-2 text-black-500 transition-colors duration-200 hover:text-black-700'
            >
              <ChevronLeft className='w-5 h-5' />
              <span className='font-IBM text-base font-medium'> 2024 Performance Report</span>
            </button>
          </div>

          <div className='flex justify-between w-full'>
            <div>
              <p className='font-IBM text-base font-normal text-primary-600'>
                Don't miss out on an opportunity to invest in our diversified baskets
              </p>
            </div>
            <div className='flex items-end w-[348px]'>
              {(Questions?.isCompleted === false || Questions.length <= 0) && (
                <Button
                  className='w-full'
                  onClick={() => navigate('/dashboard/firstTime/questionnaire')}
                >
                  Get Started
                </Button>
              )}
            </div>
          </div>

          {/* <a
            href={`${env.S3_BASE_URL}/firstTime/Performance_Report.pdf`}
            download
            target='_blank'
            rel='noreferrer'
          >
            <div className='my-10 flex gap-4 items-center border border-[#D3DBEC] py-2 pr-10 pl-3 max-w-[306px]'>
              <img src={`${env.S3_BASE_URL}/firstTime/pdf.svg`} alt='pdf icon' />
              <p className='font-DMSans font-normal text-sm text-black-400'>Download PDF</p>
            </div>
          </a> */}

          <div>
            <h1 className='font-IBM text-xl font-semibold text-black-950'>
              Fabits basket performance
            </h1>

            <div className='flex gap-5 mt-2'>
              <div className='max-w-[909px]'>
                <video
                  ref={videoRef}
                  autoPlay
                  muted
                  loop
                  className='w-full rounded-lg border border-black-100 bg-black object-contain shadow-[0_8px_24px_rgba(4,3,19,0.05)]'
                >
                  <source src={`${env.S3_BASE_URL}/firstTime/BearMarketPerformance.mp4`} />
                </video>

                <p className='mt-3 text-sm leading-5 text-black-500'>
                  Our curated baskets performed better than Nifty 50 in 2024 by diversifying your
                  investments and achieving the most optimal risk-adjusted-returns for your goals.
                </p>
              </div>

              <div className='w-[199px] flex flex-col gap-4'>
                {analyticsCards.map((details) => {
                  const { id, title, analytic } = details
                  return (
                    <div
                      key={id}
                      className='rounded-lg border border-black-100 bg-white p-3 shadow-[0_8px_24px_rgba(4,3,19,0.05)]'
                    >
                      <p
                        className={`flex items-center justify-between font-IBM text-2xl font-semibold leading-8 ${
                          id === 4 ? 'text-red-400' : 'text-secondary-600'
                        } `}
                      >
                        <span>{analytic} %</span>
                        {id != 4 && (
                          <span className='flex items-center justify-center pr-2'>
                            <Star
                              className='h-6 w-6 text-yellow-500 drop-shadow-lg'
                              fill='currentColor'
                            />
                          </span>
                        )}
                      </p>
                      <p className='font-IBM text-sm font-semibold leading-5 text-black-400'>
                        {title}
                      </p>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile and tablet mode code */}
      <div className='flex flex-col bg-[#F6F6F9] px-4 pt-4 pb-28 font-IBM lg:hidden'>
        {/* Back Button */}
        <div className='pb-4'>
          <button
            onClick={() => navigate('/dashboard')}
            className='flex items-center gap-2 text-black-500 transition-colors duration-200 hover:text-black-700'
          >
            <ChevronLeft className='w-5 h-5' />
            <span className='font-IBM text-base font-medium'> 2024 Performance Report</span>
          </button>
        </div>

        {/* <a
          href={`${env.S3_BASE_URL}/firstTime/Performance_Report.pdf`}
          download
          target='_blank'
          rel='noreferrer'
        >
          <div className='py-2 px-3 flex gap-4 rounded-[4px] font-DMSans items-center border border-[#D3DBEC]'>
            <img src={`${env.S3_BASE_URL}/firstTime/pdf.svg`} alt='pdf icon' />
            <p className='text-black-400'>Download PDF</p>
          </div>
        </a> */}

        <div>
          <div className='gap-5'>
            <div className='max-w-[909px]'>
              <h1 className='mb-3 font-IBM text-lg font-semibold leading-6 text-black-950'>
                Fabits basket performance
              </h1>
              <video
                autoPlay
                muted
                loop
                className='w-full rounded-lg border border-black-100 bg-white object-contain shadow-[0_8px_24px_rgba(4,3,19,0.05)]'
              >
                <source src={`${env.S3_BASE_URL}/firstTime/BearMarketPerformance.mp4`} />
              </video>

              <p className='mt-4 text-sm leading-5 text-black-500'>
                Our curated baskets performed better than Nifty 50 in 2024 by diversifying your
                investments and achieving the most optimal risk-adjusted-returns for your goals.
              </p>
            </div>

            <div className='mt-8 grid grid-cols-2 gap-3 pb-10'>
              {analyticsCards.map((details) => {
                const { id, title, analytic } = details
                return (
                  <div
                    key={id}
                    className='rounded-lg border border-black-100 bg-white p-3 shadow-[0_8px_24px_rgba(4,3,19,0.05)]'
                  >
                    <p
                      className={`flex items-center justify-between font-IBM text-2xl font-semibold leading-8 ${
                        id === 4 ? 'text-red-400' : 'text-secondary-600'
                      } `}
                    >
                      <span>{analytic} %</span>
                      {id != 4 && (
                        <span className='flex items-center justify-center'>
                          <Star
                            className='h-6 w-6 text-yellow-500 drop-shadow-lg'
                            fill='currentColor'
                          />
                        </span>
                      )}
                    </p>

                    <p className='font-IBM text-sm font-semibold leading-5 text-black-400'>
                      {title}
                    </p>
                  </div>
                )
              })}
            </div>
          </div>
        </div>

        {(Questions?.isCompleted === false || Questions.length <= 0) && (
          <Button className='w-full' onClick={() => navigate('/dashboard/firstTime/questionnaire')}>
            Get started
          </Button>
        )}
      </div>
    </>
  )
}

export default Returns
